// src/services/oidcApi.ts

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { UserProfile } from 'oidc-client-ts';
const baseQuery = fetchBaseQuery({
  baseUrl: '/api',
});

// Matches the processed JSON response from your backend
export interface VerifyResult {
  success: boolean;
  //awsResponse: any;
  id_token?: string;
  //access_token: string;
  //refresh_token: string;
  session?: string
  // Decoded claims and calculated expiration time from backend
  profile?: UserProfile;
  expires_at?: number; // Unix timestamp in seconds
  sub?: string
}

export interface TokentObject { t: string, signInMode: string }
const OIDC_API_BASE_URL = '/api/auth/'
export const oidcApi = createApi({
  reducerPath: 'oidcApi',
  baseQuery: fetchBaseQuery({ baseUrl: OIDC_API_BASE_URL }), // Use fetchBaseQuery directly, cantg use qryFuncWithSubHeader here
  endpoints: (builder) => ({
    //step 1: Start — returns a session identifier
    startSmsAuth: builder.mutation<{ Session: string }, { phone: string }>({
      query: (body) => ({
        url: '/start',
        method: 'POST',
        body,
      }),
    }),
    // Step 2: Verify — backend redirects, so no tokens are returned
    verifySmsCode: builder.mutation<VerifyResult, { code: string; Session: string, }>({
      query: (body) => ({
        url: '/verify',
        method: 'POST',
        body,
        // Important: allow redirects to happen normally
        //redirect: 'follow' as RequestRedirect,
      }),
      // This disables RTK Query from expecting JSON back
      // transformResponse: (response, meta, arg) => {
      //   // No data expected — success = 200 or 302
      //   return undefined;
      // },
    }),
    renewSms: builder.query<any, string | void>({//Session: string, }>({
      // optional `via` = which client path triggered the renew — DIAGNOSTIC only, logged server-side.
      query: (via) => ({ // The id, Refresh and access Token is sent automatically via the HttpOnly cookie
        url: `/renew${via ? `?via=${encodeURIComponent(via as string)}` : ''}`,
      }),

    }),
    logoutSMS: builder.query<any, void>({//Session: string, }>({
      query: () => ({ // The Refresh Token is sent automatically via the HttpOnly cookie
        url: `/logout`,
        //method: 'POST',
        //body,
        // Important: allow redirects to happen normally
        //redirect: 'follow' as RequestRedirect,
      }),

    }),
    verifyTinyToken: builder.query<any, string | TokentObject >({//Session: string, }>({
      query: (arg) => {
        const urlParms =  new URLSearchParams();//URL('/verify-tiny-token/');
        urlParms.set('tinyToken', (typeof arg) === 'string' ? arg as string: (arg as TokentObject).t)
        urlParms.set('signInMode', (typeof arg) === 'object' ? (arg as TokentObject).signInMode : 'auto');
        return ({
          url: `/verify-tiny-token/?${urlParms}`,
        })// The Refresh Token is sent automatically via the HttpOnly cookie
      }
    }),
    analyzeTinyToken: builder.query<any, string>({//Session: string, }>({
      query: (t) => ({ // The Refresh Token is sent automatically via the HttpOnly cookie
        url: `/analyze-tiny-token/?tinyToken=${encodeURIComponent(t)}`,
      }),

    }),
    //updateCongitoUserPhone
    updateCognitoUserPhone: builder.mutation<VerifyResult, { sub: string; newPhone: string, }>({
      query: (body) => ({
        url: '/updateCognitoUserPhone',
        method: 'POST',
        body,
      }),
    }),
    // /**
    //  * Retrieves a stored item by its key from the BFF.
    //  * Maps to: GET /api/oidc-store/{key}
    //  *
    //  * The BFF uses the `bffSessionId` from the HttpOnly cookie to scope the key.
    //  *
    //  * IMPORTANT: Your BFF should return a 200 OK status with a body of
    //  * "null" (as a string) or an empty string if the item is not found,
    //  * instead of a 404 Not Found status, if you want RTK Query to resolve
    //  * with `data: null` rather than `error`.
    //  *
    //  * @param {string} key - The key of the item to retrieve (e.g., "oidc.user:...").
    //  * @returns {string | null} The stored string value, or null if not found.
    //  */
    // getStoreItem: builder.query<string | null, string>({
    //   //query:(key) => `?key=${encodeURIComponent(key)}`, // Simplified query: just the URL path
    //   query: (key) => ({
    //     url: '',//`?key=${encodeURIComponent(key)}`,
    //     params: { key },
    //     // Tell RTK Query to treat the response as text
    //     responseHandler: 'text' as const,
    //   }),
    //   transformResponse: (response: string) => {
    //     // Interpret empty string or literal "null" from BFF as actual null
    //     if (response === '' || response === 'null') {
    //       return null;
    //     }
    //     return response; // Return the actual string value
    //   },
    // }),

    // /**
    //  * Stores a key-value pair on the BFF.
    //  * Maps to: POST /api/oidc-store/{key}
    //  *
    //  * The BFF uses the `bffSessionId` from the HttpOnly cookie to scope the key.
    //  *
    //  * @param {{ key: string; value: string }} args - An object containing the key and value to store.
    //  * @returns {void} No specific data returned on success.
    //  */
    // setStoreItem: builder.mutation<void, { key: string; value: string }>({
    //   query: ({ key, value }) => ({
    //     url: '',//encodeURIComponent(key),
    //     method: 'POST',
    //     body: { key, value }, // Send the value in a JSON body. Your BFF should expect `{ "value": "..." }`.
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   }),
    // }),

    // /**
    //  * Removes a stored item by its key from the BFF.
    //  * Maps to: DELETE /api/oidc-store/{key}
    //  *
    //  * The BFF uses the `bffSessionId` from the HttpOnly cookie to scope the key.
    //  *
    //  * IMPORTANT: Your BFF should return a 200 OK status (e.g., with "null" or empty body)
    //  * if the item was not found (and thus nothing was removed), instead of a 404.
    //  *
    //  * @param {string} key - The key of the item to remove.
    //  * @returns {string | null} The value of the removed item (if BFF returns it), or null.
    //  */
    // removeStoreItem: builder.mutation<string | null, string>({
    //   query: (key) => ({
    //     url: `?key=${encodeURIComponent(key)}`,
    //     method: 'DELETE',
    //   }),
    //   // transformResponse for successful (2xx) delete responses
    //   transformResponse: (response: string) => {
    //     if (response === '' || response === 'null') {
    //       return null;
    //     }
    //     return response; // BFF might return the value of the removed item
    //   },
    // }),

    // /**
    //  * Retrieves all stored keys for the current BFF session from the BFF.
    //  * Maps to: GET /api/oidc-store/keys
    //  *
    //  * The BFF uses the `bffSessionId` from the HttpOnly cookie to scope the keys.
    //  *
    //  * @returns {string[]} An array of all keys.
    //  */
    // getAllStoreKeys: builder.query<string[], void>({
    //   query: () => 'keys', // Endpoint for fetching all keys
    //   // transformResponse for successful (2xx) responses.
    //   transformResponse: (response: string[]) => response, // Assuming BFF returns a JSON array of strings
    // }),
  }),
});

// Export RTK Query hooks for use in React components
export const {
  useStartSmsAuthMutation,
  useUpdateCognitoUserPhoneMutation,
  useVerifySmsCodeMutation,
  useVerifyTinyTokenQuery, useLazyVerifyTinyTokenQuery,
  useAnalyzeTinyTokenQuery, useLazyAnalyzeTinyTokenQuery,
  useRenewSmsQuery,  useLazyRenewSmsQuery,
  useLogoutSMSQuery, useLazyLogoutSMSQuery,
  // useGetStoreItemQuery,
  // useSetStoreItemMutation,
  // useRemoveStoreItemMutation,
  // useGetAllStoreKeysQuery,

} = oidcApi;

// Export the reducer and middleware to be added to your Redux store
export const oidcApiReducer = oidcApi.reducer;
export const oidcApiMiddleware = oidcApi.middleware;